export default __webpack_public_path__ + "static/media/1893.289a661f.png";